import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

export const Root = styled.div<{ isLastFlight: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${(props) =>
    props.isLastFlight ? `rgba(${ColorPalette.RGB.DimGray2}, 0.05)` : `rgba(${ColorPalette.RGB.BrightOrange}, 0.05)`};
  height: 45px;
  padding: 10px;
  color: ${(props) => (props.isLastFlight ? ColorPalette.HEX.DimGray2 : ColorPalette.HEX.BrightOrange)};
  font-size: 10px;
  border-radius: '8px';
`;

export const TimeImg = styled.img`
  margin-right: 8px;
`;
